import { Button, Col, Input, Row, Space, Form, Tooltip, Select } from "antd";
import { ContainerData, emptyRequestDataProperties as emptyData } from "../../../../api/data-types";
import { useEffect, useState } from "react";

import "./search-types.css";
import { FolderModal } from "../../../layout/folder-modal/folder-modal";
import { FolderOutlined } from "@ant-design/icons";
import { MetadataParams } from "../../util/data-types/data-types-search-page";

import "./search-types.css";
import { StorageAPIClient } from "../../../../api/storage-api-client";
import { DefaultOptionType } from "antd/es/select";


const DEFAULT_CONTAINER_LABEL = "";

interface MetadataSearchProps {
  theme: string;
  sendDataComponent: (
    container: ContainerData,
    metaDataKey: string,
    metaDataValue: string,
    offset: number,
    previousOffset: number,
    limit: number,
    folder?: string
  ) => Promise<void>;
  limit: number;
  selectedContainer: ContainerData;
  metadataFromUrl: MetadataParams;
}

export const MetadataSearch = ({
  theme,
  sendDataComponent,
  limit,
  selectedContainer,
  metadataFromUrl,
}: MetadataSearchProps) => {
  const [form] = Form.useForm<FormData>();

  const [loading, setLoading] = useState<boolean>(false);

  const [openFolderModal, setOpenFolderModal] = useState<boolean>(false);

  const [folderPath, setFolderPath] = useState<string>("");

  const [metadataKeys, setMetadataKeys] = useState<string[]>([]);

  const updateFolderValue = (aPath: string, updatePath: boolean) => {
    setOpenFolderModal(false);
    if (updatePath) {
      setFolderPath(aPath);
      setFolderPath(aPath);
    }
  };

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onFinish = async (values: any) => {
    setLoading(true);
    await sendDataComponent(
      selectedContainer,
      values.metaDataKey,
      values.metaDataValue,
      Number(emptyData.EMPTY_OFFSET),
      Number(emptyData.EMPTY_OFFSET),
      limit,
      values.folder as string
    );
    setLoading(false);
  };

  useEffect(() => {
    if (
      selectedContainer.containerName !== "" &&
      selectedContainer.containerName !== DEFAULT_CONTAINER_LABEL
    ) {
      StorageAPIClient.getKeysFromContainer(selectedContainer.containerName)
        .then((metadataKeys) => {
          setMetadataKeys(metadataKeys);
        })
        .catch((error) => {
          console.error("Error on mount:", error.message);
        });
    }
  }, [selectedContainer]);

  useEffect(() => {
    form.setFieldValue("folder", folderPath);
  }, [folderPath]);

  useEffect(() => {
    form.setFieldValue("metaDataKey", metadataFromUrl.metaDataKey);
    form.setFieldValue("metaDataValue", metadataFromUrl.metaDataValue);
    form.setFieldValue("folder", metadataFromUrl.folder);
    if (
      selectedContainer.containerName !== "" &&
      selectedContainer.containerName !== DEFAULT_CONTAINER_LABEL
    ) {
      StorageAPIClient.getKeysFromContainer(selectedContainer.containerName)
        .then((metadataKeys) => {
          setMetadataKeys(metadataKeys);
        })
        .catch((error) => {
          console.error("Error on mount:", error.message);
        });
    }
  }, [metadataFromUrl]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <Form form={form} onFinish={onFinish}>
      <div style={{ marginTop: "10px" }}>
        <Col span={24}>
          <Row gutter={10}>
            <Col span={4} className="textOnPageColumn" style={{}}>
              <span style={{ color: "red" }}>*</span>Metadata Key
            </Col>
            <Col span={8} style={{ textAlign: "left" }}>
              <Form.Item
                name="metaDataKey"
                style={{}}
                rules={[
                  { required: true, message: "Please input metadata key" },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select a key"
                  options={
                    metadataKeys &&
                    metadataKeys.map((item) => ({ label: item, value: item }))
                  }
                  optionFilterProp="children"
                  filterOption={filterOption}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={4} className="textOnPageColumn">
              <span style={{ color: "red" }}>*</span>Metadata Value
            </Col>
            <Col span={8} style={{ textAlign: "left" }}>
              <Form.Item
                name="metaDataValue"
                style={{}}
                rules={[
                  { required: true, message: "Please input metadata value" },
                ]}
              >
                <Input style={{ color: textColor }} placeholder="Placeholder" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={4} className="textOnPageColumn">
              Folder
            </Col>
            <Col span={8} style={{ textAlign: "right" }}>
              <Form.Item
                name="folder"
                style={{
                  marginBottom: "10px",
                }}
              >
                <Input
                  style={{ color: textColor }}
                  placeholder="Placeholder"
                  value={folderPath}
                />
              </Form.Item>
            </Col>
            <Col span={1}>
              <Tooltip
                title={
                  selectedContainer.containerName === ""
                    ? "Select container to enable folder choosing"
                    : ""
                }
              >
                <Button
                  className="folderButton"
                  icon={<FolderOutlined />}
                  onClick={() => {
                    setOpenFolderModal(() => true);
                  }}
                  disabled={selectedContainer.containerName === ""}
                />
                <FolderModal
                  theme={theme}
                  isOpen={openFolderModal}
                  containerName={selectedContainer.containerName}
                  rootFolderPath={folderPath}
                  sendPathToParent={updateFolderValue}
                  showInput={false}
                  numberOfDisabledInPath={0}
                />
              </Tooltip>
            </Col>
          </Row>
          <Row gutter={0} align="top">
            <Col span={4} className="textOnPageColumn">
              &nbsp;
            </Col>
            <Col span={8}>
              <Form.Item style={{ marginBottom: "0px" }}>
                <Button
                  className="searchButton"
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </div>
    </Form>
  );
};
